module.exports = __webpack_public_path__ + "img/20190727142022842.e28fbd31.png";